import type { ReactNode } from "react";
import { Box } from "@mui/material";

interface AppBarIconProps {
	readonly children: ReactNode;
}

export const AppBarIcon = ({ children }: AppBarIconProps) => (
	<Box
		data-testid="app-bar-icon"
		sx={{
			display: "flex",
			alignItems: "center",
			width: 32,
			height: 32,
			flexShrink: 0,
			overflow: "hidden",
			"& > img, & > svg": {
				display: "block",
				height: "100%",
				width: "100%",
			},
		}}
	>
		{children}
	</Box>
);
